@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.subscription {
  @include breakpoints.tablet {
    display: grid;
    grid-template-columns: 110px 1fr;
    gap: 24px;
    align-items: top;
    padding: 0 20px;
    margin-top: 20px;
  }
}

.thumbnail {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin-top: 15px;

  @include breakpoints.tablet {
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    align-items: center;
  }
}

.thumbnailIcon {
  height: 30px;

  @include breakpoints.tablet {
    height: 80px;
  }
}

.thumbnailDescription {
  @include typography.body;

  @include breakpoints.tablet {
    @include typography.caption;
  }
}

.data {
  @include breakpoints.tablet {
    margin: 0;
    border: 1px solid var(--blue-03);
    border-radius: 20px;
    padding: 16px 24px;
    background-color: var(--blue-03);
  }
}

.dataNew {
  margin-top: 18px;
  display: grid;
  gap: 8px;
  background-color: var(--blue-03);
  border-radius: 20px;
  padding: 10px;
  @include breakpoints.tablet {
    grid-template-columns: 2fr 2fr 2fr 2fr 3fr;
  }
}
.item {
  display: flex;
  justify-content: space-between;

  @include breakpoints.tablet {
    gap: 4px;
    flex-direction: column;
    justify-content: flex-start;
  }
}

.largeItem {
  margin: 8px -12px 0; // Hack to make the gray area "bleed" into gutter on mobile
  border: 1px solid var(--blue-03);
  border-radius: 4px 4px 0 0;
  padding: 16px;
  background-color: var(--gray-04-at-30);
  display: flex;
  flex-direction: column;
  gap: 4px;

  @include breakpoints.tablet {
    // Unset all of the "gray area" behavior from mobile
    border-radius: 4px;
    margin: 0;
    border: none;
    padding: 0;
    background-color: unset;
  }
}

.prop {
  font-family: Montserrat;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  line-height: 22.4px;
  letter-spacing: 0.32px;
  vertical-align: middle;

  @include breakpoints.desktop{
    font-size: 16px;
    line-height: 200%;
    letter-spacing: 0%;
  }

}

.value {
  font-family: Montserrat;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 22.4px;
  letter-spacing: 0.32px;
  vertical-align: middle;

  @include breakpoints.desktop{
    font-size: 16px;
    ine-height: 200%;
    letter-spacing: 0%;
  }

}

.byline {
  @include typography.caption;

  color: var(--black-at-75);
}

.promisedDate {
  margin-top: 8px;

  @include typography.caption;
}

.destinationBar {
  background-color: var(--blue-03);
  padding: 10px 0;
  text-align: center;
  margin: -8px -12px 0;
  border-radius: 0 0 4px 4px;

  @include breakpoints.tablet {
    grid-column: 1 / -1;
    text-align: center;
    padding: 10px 0;
    background-color: var(--blue-03);
    margin: 8px -24px -16px;
    color: var(--blue-01);
  }

  @include typography.caption;
}

.destination {
  @include typography.caption-semibold;
}

.logo {
  margin-right: 8px;
  vertical-align: text-top;
}




.redText {
  color: red;
  font-size: 12px;
  font-style: italic;
  text-align: center;
  font-family: typography.$font-mont;
  @include breakpoints.tablet {
    text-align: initial;
  }
}

.btn {
  width: 100%;
  font-weight: bold;
  font-family: Monsterrat;
}


.active {
  color: green;
  font-weight: bold;
}

.failed {
  color: red;
  font-weight: bold;
}

.canceled {
  color: grey;
  font-weight: bold;
}

.prodMobile {
  display: block;
  font-weight: bold;
  font-family: Monsterrat;
  @include breakpoints.tablet {
    display: none;
  }
}

.mobHide {
  display: none;
  @include breakpoints.tablet {
    display: block;
  }
}

.bgMobile {
  margin: 0px -10px;
  border: 1px solid var(--blue-03);
  border-radius: 4px;
  padding: 10px 10px;
  background-color: var(--gray-04-at-30);
}

.mobileView {
  display: block;
  @include breakpoints.tablet {
    display: none;
  }  
}

.desktopView {
  display: none;
  @include breakpoints.tablet {
    display: block;
  }  
}

.marStatus {
  margin-bottom: 10px;
}